import moment from 'moment';
import {notAuthorizedMessage} from '../services/not-authorized.js';

export default function MemberCalendarCtrl($scope, $wamp, $stateParams, progressBar, $state, $timeout, uiCalendarConfig, $mdMedia) {

  const startDate = $stateParams.query.replace(/-/g, "/");
  $scope.displayCalendar = !$stateParams.query;
  $scope.currentDate = $stateParams.query && moment(startDate).format('M/D/YYYY');
  $scope.start = startDate;
  $scope.mdMedia = $mdMedia;
  $scope.refused = null;   // the backend's message when it won't show this login its trades

  // A login the backend won't show its trades to (no trading access): its message in place of them.
  // Any other failure goes to the console, as before.
  function showRefusal(err) {
    const message = notAuthorizedMessage(err);
    if (!message) {
      console.error(err);
      return;
    }
    $scope.$applyAsync(function () {
      $scope.refused = message;
    });
  }

  if (!$scope.displayCalendar) {
    progressBar.add('org.eggs.trades_for_date');
    $wamp.call('org.eggs.trades_for_date', [moment(startDate).format('M/D/YYYY')]).then(function (res) {
      progressBar.remove('org.eggs.trades_for_date');
      $scope.results = res;
    }, function (err) {
      progressBar.remove('org.eggs.trades_for_date');
      showRefusal(err);
    });
  }

  $timeout(function () {
    if ($stateParams.start && uiCalendarConfig.calendars.myCalendar) {
      uiCalendarConfig.calendars.myCalendar.fullCalendar('gotoDate', $stateParams.start.replace(/-/g, "/"));
    }
  });

  let calendarTimer;
  const tradeEvents = function (start, end, timezone, callback) {

    $timeout(function () {
      var date = uiCalendarConfig.calendars.myCalendar.fullCalendar('getDate');
      if (date._isAMomentObject && date._isAMomentObject === true) {
        $state.go('^.calendar', {start: date.format('YYYY-M-D')}, {notify: false});
      }
    });

    calendarTimer = $timeout(function () {
      $wamp.call('org.eggs.trade_calendar', [start.format('M/D/YYYY'), end.format('M/D/YYYY')]).then(function (res) {
        var events = res.map(function (trade) {
          return trade;
        });
        callback(events);
        progressBar.remove('org.eggs.trade_calendar');
      }, function (err) {
        progressBar.remove('org.eggs.trade_calendar');
        callback([]);
        showRefusal(err);
      });
    }, 100);
  };

  const onEventClick = function (data, jsEvent, view) {
    $state.go('member.account.calendar', {query: data.start.format('M-D-YYYY')});
  };

  $scope.uiConfig = {
    calendar: {
      height: 450,
      editable: true,
      header: {
        left: 'prev',
        center: 'title',
        right: 'next'
      },
      eventClick: onEventClick
    }
  };

  $scope.eventSources = [tradeEvents];
}
